import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';
import api, { ApiResult } from '../../../api/api-caller';

interface CacheData {
  [key: string]: any;
}

export interface Titles {
  title?: string;
  description?: string;
  link?: string;
}

export interface LandingPageState {
  data: Titles;
  error: ErrorObject;
}

export interface LandingPageViewModelType {
  fetchTitles(): Promise<ApiResult>;
  getTitles(): Promise<LandingPageState>;
}

const viewModelCache: CacheData = {};

const createLandingPageViewModel = (): LandingPageViewModelType => {
  let data;

  const getTitlesFromAPI = async (): Promise<ApiResult> => {
    const call = {
      body: {},
      method: 'GET'
    };

    const result: ApiResult = await api.asyncCallApi('landingpage', call);

    return result;
  };

  const fetchTitles = async (): Promise<ApiResult> => {
    const cacheKey: string = '';

    if (viewModelCache[cacheKey]) {
      console.log('From cache', viewModelCache[cacheKey]);
      data = viewModelCache[cacheKey];
    } else {
      data = await getTitlesFromAPI();
      viewModelCache[cacheKey] = data;
    }
    return data;
  };

  const getTitles = async (): Promise<LandingPageState> => {
    try {
      const titles = await fetchTitles();

      if (!titles.ok) {
        return {
          data: { title: '', description: '' },
          error: titles.error || { message: 'Something went wrong', details: '' }
        };
      }

      return {
        data: {
          title: titles.data.title,
          description: titles.data.description,
          link: titles.data.link
        },
        error: { message: '', details: '' }
      };
    } catch (error) {
      return {
        data: { title: '', description: '' },
        error: { message: 'Server unreachable', details: JSON.stringify(error) }
      };
    }
  };

  return {
    fetchTitles,
    getTitles
  };
};

export default createLandingPageViewModel;
